import { MapContainer, TileLayer, Marker, Polyline, useMap } from "react-leaflet";
import { useEffect, useMemo } from "react";
import L from "leaflet";

// Fix default icon issue
delete L.Icon.Default.prototype._getIconUrl;

const ABU_DHABI = [24.4539, 54.3773];

function divIcon(className, html = "") {
  return L.divIcon({
    className: "",
    html: `<div class="${className}">${html}</div>`,
    iconSize: [0, 0],
    iconAnchor: [18, 18],
  });
}

function FlyTo({ position }) {
  const map = useMap();
  useEffect(() => {
    if (position) map.flyTo(position, map.getZoom() < 13 ? 13 : map.getZoom(), { duration: 0.6 });
  }, [position, map]);
  return null;
}

export default function MapView({
  center = ABU_DHABI,
  zoom = 12,
  userLocation = null,
  vehicles = [],
  pickup = null,
  dropoff = null,
  driver = null,
  route = null,
  flyTo = null,
  height = "100%",
  className = "",
  style = "light",
}) {
  const tileUrl = useMemo(
    () =>
      style === "dark"
        ? "https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
        : "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png",
    [style]
  );

  const carSvg =
    '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 17h14M6 12l1.5-4.5A2 2 0 0 1 9.4 6h5.2a2 2 0 0 1 1.9 1.5L18 12M5 17v3M19 17v3M7 12h10v5H7z"/></svg>';

  return (
    <div className={className} style={{ height, width: "100%" }}>
      <MapContainer
        center={center}
        zoom={zoom}
        style={{ height: "100%", width: "100%" }}
        zoomControl={false}
        attributionControl={true}
        scrollWheelZoom={true}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/">OSM</a> &copy; CARTO'
          url={tileUrl}
        />
        {flyTo && <FlyTo position={flyTo} />}

        {userLocation && (
          <Marker position={userLocation} icon={divIcon("marker-pulse")} />
        )}

        {vehicles.map((v) =>
          v.current_lat && v.current_lng ? (
            <Marker
              key={v.id}
              position={[v.current_lat, v.current_lng]}
              icon={divIcon("marker-vehicle", carSvg)}
            />
          ) : null
        )}

        {pickup && (
          <Marker position={[pickup.lat, pickup.lng]} icon={divIcon("marker-pickup")} />
        )}
        {dropoff && (
          <Marker position={[dropoff.lat, dropoff.lng]} icon={divIcon("marker-dropoff")} />
        )}
        {driver && driver.lat && (
          <Marker position={[driver.lat, driver.lng]} icon={divIcon("marker-vehicle", carSvg)} />
        )}

        {route && route.length > 1 && (
          <Polyline
            positions={route}
            pathOptions={{ color: "#22B8E0", weight: 5, opacity: 0.85 }}
          />
        )}
      </MapContainer>
    </div>
  );
}
